import React from 'react';
import './PlayerCard.css';

function PlayerCard({ player }) {
  return (
    <div className="player-card">
      <div className="player-rank">
        <span className="rank-number">#{player.rank}</span>
      </div>

      <div className="player-info">
        <div className="player-name">{player.name}</div>
      </div>

      {player.deltaRank !== null && player.deltaRank !== 0 && (
        <div className={`delta-rank ${player.deltaRank > 0 ? 'up' : 'down'}`}>
          {player.deltaRank > 0 ? `▲${player.deltaRank}` : `▼${Math.abs(player.deltaRank)}`}
        </div>
      )}
    </div>
  );
}

export default PlayerCard;
